import "./App.css";
import { Routes, Route, Link } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Works from "./pages/Works";

function App() {
  document.onkeypress = function (e) {
    e = e || window.event;
    if (e.keyCode === 13) {
      document.documentElement.classList.toggle("darkmode");
      document.querySelectorAll(".project-image-hover").forEach((result) => {
        result.classList.toggle("invert");
      });
    }
  };
  return (
    <div className="App">
      <div className="cursor"></div>
      <div>
        <Routes>
          <Route path="/" element={<Homepage />}></Route>
          <Route path="/works" element={<Works />}></Route>
        </Routes>
      </div>
    </div>
  );
}

export default App;
